// extracted by mini-css-extract-plugin
module.exports = {"item":"RearrangeImages_item__kLIRL","itemDragging":"RearrangeImages_itemDragging__Icmto"};